import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59d0d82d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-lg container-fluid py-4" }
const _hoisted_2 = { class: "d-flex w-100 justify-content-between align-items-center" }
const _hoisted_3 = { class: "text-primary mb-0" }
const _hoisted_4 = { class: "my-3" }
const _hoisted_5 = { class: "card border-0 shadow-sm" }
const _hoisted_6 = { class: "p-d-flex p-flex-md-wrap p-ai-center p-jc-between" }
const _hoisted_7 = { class: "p-input-icon-left" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))
const _hoisted_9 = { class: "p-text-center" }
const _hoisted_10 = { class: "p-text-center" }
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "d-flex justify-content-center" }
const _hoisted_13 = { class: "confirmation-content" }
const _hoisted_14 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h5", _hoisted_3, _toDisplayString(_ctx.title), 1),
      _createVNode(_component_Button, {
        label: "Invite Program Coordinator",
        icon: "pi pi-plus-circle",
        class: "p-button-sm p-button-raised mb-1 p-button-text",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.addProgramCoordinator()), ["prevent"]))
      })
    ]),
    _createElementVNode("main", _hoisted_4, [
      _createElementVNode("section", _hoisted_5, [
        _createVNode(_component_DataTable, {
          responsiveLayout: "scroll",
          breakpoint: "700px",
          value: _ctx.getProgCords,
          paginator: true,
          loading: _ctx.loading,
          rows: 10,
          selectionMode: "single",
          columnResizeMode: "fit",
          scrollHeight: "flex",
          globalFilterFields: ['username', 'email'],
          filters: _ctx.filters,
          "onUpdate:filters": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters) = $event)),
          filterDisplay: "menu"
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_Button, {
                type: "button",
                icon: "pi pi-filter-slash",
                label: "Clear",
                class: "p-button-outlined",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clearFilter()))
              }),
              _createElementVNode("span", _hoisted_7, [
                _hoisted_8,
                _createVNode(_component_InputText, {
                  modelValue: _ctx.filters['global'].value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters['global'].value) = $event)),
                  placeholder: "Keyword Search ..."
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          empty: _withCtx(() => [
            _createElementVNode("h6", _hoisted_9, "No " + _toDisplayString(_ctx.title) + " found.", 1)
          ]),
          loading: _withCtx(() => [
            _createElementVNode("h6", _hoisted_10, " Loading " + _toDisplayString(_ctx.title) + " data. Please wait. ", 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, { header: "#" }, {
              body: _withCtx(({ index }) => [
                _createTextVNode(_toDisplayString(index + 1), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              field: "email",
              header: "Email",
              sortable: true,
              frozen: true
            }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("a", {
                  href: `mailto:${slotProps.data.email}?subject=BHMIS`,
                  class: "text-dark"
                }, _toDisplayString(_ctx.trimText(slotProps.data.email, 25)), 9, _hoisted_11)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              header: "Name",
              sortable: true,
              frozen: true,
              style: {"min-width":"15rem"}
            }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(slotProps.data.last_name + ", " + slotProps.data.first_name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              field: "username",
              header: "Username",
              sortable: true,
              frozen: false
            }),
            _createVNode(_component_Column, {
              field: "employee_number",
              header: "Employee-Number",
              style: {"min-width":"5rem"},
              sortable: true,
              frozen: false
            }),
            _createVNode(_component_Column, {
              exportable: false,
              header: "",
              style: {"min-width":"4rem"}
            }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_Button, {
                    label: "",
                    icon: "pi pi-trash",
                    class: "p-button-sm p-button-raised mb-1 p-button-danger",
                    onClick: ($event: any) => (_ctx.deleteUser(slotProps.data.id))
                  }, null, 8, ["onClick"]),
                  _createVNode(_component_Button, {
                    label: "",
                    icon: "pi pi-pencil",
                    class: "p-button-sm p-button-raised mb-1 p-button-info",
                    onClick: ($event: any) => (_ctx.getOfficial(slotProps.data.id))
                  }, null, 8, ["onClick"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value", "loading", "filters"])
      ])
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.dataDialog,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dataDialog) = $event)),
      style: { width: '40rem' },
      header: _ctx.data ? _ctx.data.username : 'Official',
      modal: true
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "Cancel",
          icon: "pi pi-times",
          class: "p-button",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.dataDialog = false))
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, [
          (_ctx.data)
            ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                _createElementVNode("h5", null, _toDisplayString(_ctx.data.email), 1),
                _createElementVNode("h6", null, _toDisplayString(_ctx.data.department), 1),
                _createElementVNode("h6", null, _toDisplayString(_ctx.data.username), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["visible", "header"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.inviteDialog,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.inviteDialog) = $event)),
      style: { width: '40rem' },
      header: _ctx.title,
      modal: true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Form, { onClose: _ctx.closeInviteDialog }, null, 8, ["onClose"])
      ]),
      _: 1
    }, 8, ["visible", "header"])
  ]))
}